module.exports = __webpack_public_path__ + "img/game_main_pc_244_off.e01e1821.png";